import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-factura',
  templateUrl: './factura.component.html',
  styleUrls: ['./factura.component.scss']
})
export class FacturaComponent  {

  user:any;
  flag:boolean = true;
  constructor(private loginService:LoginService) {
    
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.flag = (this.user.id_roles == 45)? false: true;
   }



  clickGuard(){
    this.loginService.clickGuard = true;
 }


}
